import {
    isNonEmptyString,
    isRecord,
    isValidV1EventEnvelope,
} from '@/utils/eventEnvelope'

export const PRINT_EVENT_TYPES = {
    RESULT: 'print.result',
    ERROR: 'print.error',
}

const PRINT_EVENT_TYPE_SET = new Set(Object.values(PRINT_EVENT_TYPES))

const isNonNegativeInteger = value => Number.isInteger(value) && value >= 0

const isPositiveInteger = value => Number.isInteger(value) && value > 0

const isValidUnprintedItem = item =>
    isRecord(item) &&
    (item.code === undefined || isNonEmptyString(item.code)) &&
    isNonEmptyString(item.message) &&
    isPositiveInteger(item.count)

const isValidResultData = data =>
    isRecord(data) &&
    isNonNegativeInteger(data.printed_count) &&
    isNonNegativeInteger(data.unprinted_count) &&
    Array.isArray(data.unprinted) &&
    data.unprinted.every(isValidUnprintedItem)

const isValidErrorData = data =>
    isRecord(data) && isNonEmptyString(data.message)

export const isValidInvoicePrintEnvelope = envelope =>
    isValidV1EventEnvelope(envelope, {
        eventTypes: PRINT_EVENT_TYPE_SET,
        validateData: (type, data) =>
            type === PRINT_EVENT_TYPES.RESULT
                ? isValidResultData(data)
                : isValidErrorData(data),
    })
